module.exports = __webpack_public_path__ + "img/notice_bg.da860b0e.png";